import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/shared/dataservice.service';

@Component({
  selector: 'app-prod-high',
  templateUrl: './prod-high.component.html',
  styleUrls: ['./prod-high.component.css']
})
export class ProdHighComponent implements OnInit {

  
  selView:number = 0;
  mId: string = "7371ba17-9f08-4da0-6fc0-f2f7c8686504";
  hasmodaccess: boolean = false;
  

  constructor(public _dataService: DataService) { }

  ngOnInit() {
    this._dataService.currPageName = "Production Plan";
        
  }

  checkModAccess(): boolean {
    if (this._dataService.mAccess(this.mId) == true) {
      this.hasmodaccess = true;
    }
    else {
      this.hasmodaccess = false;
    }
    return this.hasmodaccess;
  }
  
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
}
